import React from 'react';
import '../styles/Footer.css';

const Footer: React.FC = () => {
    return (
        <footer>
            <div className="footer-section">
                <h3>🛡️ Uma Shankar Security Agency</h3>
                <p>"We Save Your Assets"</p>
                <p>Professional Security & Manpower Solutions</p>
            </div>
            <div className="footer-section">
                <h3>📞 Contact</h3>
                <p>📧 info.ussagency.com</p>
                <p>📱 +91 74154 05250</p>
                <p>📍 Location: GF 153 Khazana Complex, Ashiyana, UP, 226012,Lucknow India</p>
            </div>
            <div className="footer-section">
                <h3>⚔️ Services</h3>
                <p>• Security Guards (24/7)</p>
                <p>• Armed Security</p>
                <p>• Manpower Solutions</p>
                <p>• Event Security</p>
            </div>
            <div className="footer-section">
                <h3>👨✈️ Leadership</h3>
                <p>Lt. Col. Uma Shankar (Retd)</p>
                <p>39 Years Military Experience</p>
                <p>Indian Army Infantry</p>
            </div>
        </footer>
    );
};

export default Footer;